import { parse, parseUrl } from 'query-string';
import { LanguageType } from '../../../types/language';
import { appendLocalStorage, getLocalStorage } from '../localStorage';
import { LinkType, NativeApi, Platform } from './interface';
import { getDevLang } from './utils';

const MOBILE_TOKEN = 'mobile_token';
const MOBILE_H5_LANG = 'mobile_h5_lang';
const MOBILE_H5_HEADER_PARAMS = 'mobile_h5_header_params';

// web H5

export const mobileWebClient: NativeApi = {
  name: Platform.MobileWebClient,
  token: '',
  headerParams: {},
  h5LinkType: undefined,
  isNewVersion: undefined,
  async init(options = {}) {
    const { initLangCallBack } = options;
    const { query } = parseUrl(location.href);
    this.token = (query.token as string) || '';
    this.headerParams = getLocalStorage(MOBILE_H5_HEADER_PARAMS) || {};
    initLangCallBack?.(this?.getLanguage() as LanguageType);
  },
  getLanguage: () => {
    const params = parse(location.search);
    const lowerLang = params.lang?.toString().toLocaleLowerCase();
    if (lowerLang) {
      appendLocalStorage(MOBILE_H5_LANG, { lang: lowerLang });
      return lowerLang || getDevLang();
    }
    const lang = getLocalStorage(MOBILE_H5_LANG)?.lang;
    if (lang) {
      return lang || getDevLang();
    }
    return getDevLang();
  },
  closeWindow: () => {
    // 跳到下载提示页面
    window.navigateFunc?.('/vhk/webPub/download');
  },
  gotoWhatsApp: () => {
    location.href = 'https://wa.me/85263692338';
  },
  getToken() {
    if (!this.token) {
      this.token = getLocalStorage(MOBILE_TOKEN).token || '';
    }
    return this.token;
  },
  setToken(token: string) {
    this.token = token;
    appendLocalStorage(MOBILE_TOKEN, { token });
  },
  setRequestHeader(header: Record<string, string>) {
    console.log('🚀 ~ setRequestHeader ~ header:', header);
    this.headerParams = { ...this.headerParams, ...header };
    appendLocalStorage(MOBILE_H5_HEADER_PARAMS, this.headerParams);
  },
  setH5LinkType(linkType: LinkType) {
    this.h5LinkType = linkType;
  },
  getRequestHeader() {
    return {
      uiVersion: this.isNewVersion ? 'N' : 'O',
      ...this.headerParams,
    };
  },
  setIsNewVersion(isNewVersion: boolean) {
    this.isNewVersion = isNewVersion;
  },
  getIsNewVersion() {
    if (typeof this.isNewVersion !== 'boolean') {
      this.isNewVersion = true;
      return this.isNewVersion;
    }
    return this.isNewVersion;
  },
};
